import { EnumSchema } from '../metadata-schema';

export const CategorieUitstroomniveauVSO: EnumSchema = {
	"type": "string",
	"title": "CategorieUitstroomniveauVSO",
	"enum": [
		"Vervolgonderwijs",
		"Arbeid"
	]
};
